import React from "react";
import Container from "../ui/Container";
import Card from "../ui/Card";
import { Shield, DatabaseBackup, Gauge, Mail, Wrench, LifeBuoy } from "lucide-react";

function Item({ icon: Icon, title, body }) {
  return (
    <Card className="p-7 sm:p-8">
      <div className="flex items-start gap-4">
        <div className="grid h-11 w-11 place-items-center rounded-2xl border border-white/10 bg-white/[0.03]">
          <Icon className="h-5 w-5 text-cyan-300" />
        </div>
        <div>
          <div className="text-sm font-semibold text-white">{title}</div>
          <p className="mt-2 text-sm leading-6 text-white/65">{body}</p>
        </div>
      </div>
    </Card>
  );
}

export default function WebHostingValue() {
  const items = [
    {
      icon: Gauge,
      title: "Fast by default",
      body: "NVMe storage and a modern stack tuned for real-world performance.",
    },
    {
      icon: DatabaseBackup,
      title: "Backups included",
      body: "Daily backups on all plans so mistakes don’t become disasters.",
    },
    {
      icon: Shield,
      title: "Security basics included",
      body: "SSL included. Clean defaults. Sensible hardening.",
    },
    {
      icon: Mail,
      title: "Email when you want it",
      body: "Keep email separate or bundled — whichever fits your setup.",
    },
    {
      icon: Wrench,
      title: "Developer-friendly",
      body: "Run common stacks cleanly without fighting your host.",
    },
    {
      icon: LifeBuoy,
      title: "Human support",
      body: "Discord + tickets. If something breaks, you get real help.",
    },
  ];

  return (
    <section className="bg-[#070A0F] py-20">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="text-xs font-semibold tracking-wider text-white/50">WHY XA</div>
          <h2 className="mt-3 text-balance text-4xl font-semibold leading-[0.95] tracking-tight text-white sm:text-5xl">
            Web hosting without the nonsense<span className="text-cyan-300">.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-white/70 sm:text-lg">
            Clean plans, good defaults, and support that doesn’t make you regret choosing a host.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((it) => (
            <Item key={it.title} icon={it.icon} title={it.title} body={it.body} />
          ))}
        </div>
      </Container>
    </section>
  );
}
